import 'react-date-range/dist/styles.css' // main style file
import 'react-date-range/dist/theme/default.css' // theme css file
import './styles.scss'
import React, { useCallback, useState } from 'react'
import Button from '../../Button'
import Container from '../../Container'
import styles from '../datepicker.module.scss'
import { Calendar, DateRangePicker } from 'react-date-range'
import { subWeeks } from 'date-fns'
import PropTypes from 'prop-types'
import clsx from 'clsx'
import { Icon } from '../../index'

const now = new Date()
const startDate = subWeeks(now, 2)

const DatepickerComponent = ({
  value = { key: 'selection', startDate, endDate: now },
  onApply = () => {},
  locale,
  buttonLabels = { dropSelection: 'Drop', applySelection: 'Apply' },
  defaultStaticRanges = [],
  months = 1,
  mode = 'date-range',
  datePickerClassName = '',
  minDate = undefined,
  maxDate = undefined,
}) => {
  const [currentValue, setCurrentValue] = useState(value)

  const onChangeHandle = useCallback(
    (val) => setCurrentValue(val.selection || val),
    [setCurrentValue],
  )

  const applyRange = useCallback(
    () => onApply(currentValue),
    [onApply, currentValue],
  )

  const handleReset = () => setCurrentValue(value)

  return (
    <div className={clsx(styles['datepicker__dropdown'], datePickerClassName)}>
      {mode === 'date-range' ? (
        <DateRangePicker
          YearArrowIconPrev={() => (
            <Icon
              name={'arrow-previous'}
              size={'m'}
              color={'Interface-Seventh'}
            />
          )}
          YearArrowIconNext={() => (
            <Icon name={'arrow-next'} size={'m'} color={'Interface-Seventh'} />
          )}
          MonthArrowIconPrev={() => (
            <Icon name={'arrow-left'} size={'m'} color={'Interface-Seventh'} />
          )}
          MonthArrowIconNext={() => (
            <Icon name={'arrow-right'} size={'m'} color={'Interface-Seventh'} />
          )}
          showMonthAndYearPickers={false}
          showDateDisplay={false}
          showYearArrow={true}
          showEachMonth={true}
          showMonthName={false}
          retainEndDateOnFirstSelection={true}
          scroll={{ enabled: false }}
          rangeColors={['#F1F6FF']}
          showSelectionPreview={false}
          showPreview={false}
          inputRanges={[]}
          staticRanges={defaultStaticRanges}
          months={months}
          locale={locale}
          direction="horizontal"
          ranges={[currentValue]}
          onChange={onChangeHandle}
          minDate={minDate}
          maxDate={maxDate}
          weekdayDisplayFormat={'EEEEEE'}
        />
      ) : (
        <Calendar
          showYearArrow={true}
          onChange={onChangeHandle}
          showSelectionPreview={false}
          months={1}
          scroll={{ enabled: false }}
          showPreview={false}
          showDateDisplay={false}
          locale={locale}
          showMonthName={false}
          direction="horizontal"
          showMonthAndYearPickers={true}
          date={currentValue}
          minDate={minDate}
          maxDate={maxDate}
          weekdayDisplayFormat={'EEEEEE'}
          YearArrowIconPrev={() => (
            <Icon
              name={'arrow-previous'}
              size={'m'}
              color={'Interface-Seventh'}
            />
          )}
          YearArrowIconNext={() => (
            <Icon name={'arrow-next'} size={'m'} color={'Interface-Seventh'} />
          )}
          MonthArrowIconPrev={() => (
            <Icon name={'arrow-left'} size={'m'} color={'Interface-Seventh'} />
          )}
          MonthArrowIconNext={() => (
            <Icon name={'arrow-right'} size={'m'} color={'Interface-Seventh'} />
          )}
        />
      )}
      <Container
        className={clsx(
          'datepicker__action-button-wrapper',
          styles['datepicker__action-button-wrapper'],
        )}
        display="flex"
        flexAlign="center"
        flexJustify="flex-end"
      >
        <Button
          size="l"
          variant={'ghost'}
          color={'Label-Fifth'}
          onClick={handleReset}
          className={styles['datepicker__action-button']}
        >
          {buttonLabels.dropSelection}
        </Button>
        <Button
          size="l"
          className={styles['datepicker__action-button']}
          variant="primary"
          onClick={applyRange}
        >
          {buttonLabels.applySelection}
        </Button>
      </Container>
    </div>
  )
}

DatepickerComponent.propTypes = {
  value: PropTypes.object,
  onApply: PropTypes.func,
  locale: PropTypes.object,
  buttonLabels: PropTypes.object,
  defaultStaticRanges: PropTypes.array,
  months: PropTypes.number,
  mode: PropTypes.oneOf(['date-range', 'calendar']),
  datePickerClassName: PropTypes.string,
  minDate: PropTypes.instanceOf(Date),
  maxDate: PropTypes.instanceOf(Date),
}

export default DatepickerComponent
